import styled from 'styled-components';

interface RescueIntroProps {
  onClick?: () => void;
}

const IntroVictim = ({ onClick }: RescueIntroProps) => {
  return (
    <IntroVictimTemplate>
      <IntroWrap>
        <ImageWrap>
          <img src={process.env.PUBLIC_URL + '/images/img_intro.svg'} alt="intro" />
        </ImageWrap>
        <ImageWrap>
          <img src={process.env.PUBLIC_URL + '/images/img_intro_title.svg'} alt="title" />
        </ImageWrap>
        <IntroText>
          아래의 버튼을 눌러
          <br />
          현장위치를 해양경찰에게 전송해 주세요.
        </IntroText>
      </IntroWrap>
      <AgreeButton onClick={onClick}>{'위치전송하기'}</AgreeButton>
    </IntroVictimTemplate>
  );
};

const IntroVictimTemplate = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #000d3a 0%, #000d3a 100%);
`;
const IntroWrap = styled.div`
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -30%);
  align-items: center;
  text-align: center;
  white-space: pre-line;
`;
const ImageWrap = styled.div`
  align-items: center;
  text-align: center;
  margin-bottom: 10px;
`;
const IntroText = styled.h1`
  width: 220px;
  margin-top: 60px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 30px;
  align-items: center;
  text-align: center;
  color: #ffffff;
`;
const AgreeButton = styled.button`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 300px;
  height: 46px;
  border-radius: 5px;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 20px;
  align-items: center;
  text-align: center;
  color: #001b61;
  background: #ffffff;
  cursor: pointer;
`;

export default IntroVictim;
